// extracted by mini-css-extract-plugin
export default {"title":"PhoneVerifyModal_title__Dpbo0","subtitle":"PhoneVerifyModal_subtitle__WvEHC","modal":"PhoneVerifyModal_modal__Py9da"};